export default [
  {
    path: "/campanias",
    component: () => import("@/views/campanias/Listar.vue"),
  },
  {
    path: "/campanias/crear",
    component: () => import("@/views/campanias/Crear.vue"),
  },
  {
    path: "/campanias/editar/:id",
    component: () => import("@/views/campanias/Editar.vue"),
  },
];
